"use strict";
exports.__esModule = true;
exports.dispatchErrorEvent = exports.ERROR_EVENT_NAME = exports.serialize = void 0;
exports.serialize = function (obj) {
    var str = [];
    for (var p in obj)
        if (obj.hasOwnProperty(p)) {
            str.push(encodeURIComponent(p) + '=' + encodeURIComponent(obj[p]));
        }
    return str.join('&');
};
exports.ERROR_EVENT_NAME = 'booking-state-manager_websdk-error';
var createErrorEvent = function (err) { return new CustomEvent(exports.ERROR_EVENT_NAME, { detail: err }); };
exports.dispatchErrorEvent = function (err) { return window.dispatchEvent(createErrorEvent(err)); };
//# sourceMappingURL=utils.js.map